var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Idle_10_Transfer"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_10_Transfer",
    clipPath: "url(#clip-Icons_Idle_10_Transfer)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Idle_10_Transfer-2",
    "data-name": "Icons_Idle_10_Transfer",
    transform: "translate(-11.143 -13.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(91.128 27.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M435.323,40.7c-.378-5.671-1.512-11.342-4.537-16.257s-8.7-8.317-14.367-7.561c-3.025.378-5.293,1.89-7.939,3.4C365.759,45.232,326.44,74.344,285.986,102.7c-48.015,33.648-96.407,66.918-144.422,100.566-21.172,14.745-43.1,27.977-63.515,43.478-10.964,8.317-51.8,34.4-44.99,51.8,2.268,5.671,7.561,9.452,12.476,12.854,8.7,5.671,17.391,11.342,26.465,16.257,14.745,7.561,52.551,15.5,49.9,35.916-3.4,28.355-7.939,56.71-9.452,85.443-.756,15.879-1.89,46.124,13.989,55.2,15.5,8.7,33.648-4.915,45.746-18.147a890.122,890.122,0,0,0,67.674-83.175c21.55,11.342,43.478,19.66,65.784,29.111,14.367,6.049,39.319,24.2,54.442,8.318,10.208-10.964,10.208-43.478,12.854-58.222,11.342-59.357,22.684-118.335,34.026-177.692,4.915-26.087,10.208-52.173,15.123-78.26C427.762,97.028,437.97,71.319,435.323,40.7ZM233.813,325.381c-7.939,10.586-30.245,45.368-40.453,59.357-3.4,4.915-26.087,31-25.709,31.758A691.77,691.77,0,0,0,165,332.564c-.378-3.781-.756-7.561,1.134-10.586a13.032,13.032,0,0,1,4.537-4.537c16.257-13.232,13.988-13.232,28.355-28.355C229.276,256.572,307.914,172.263,311.7,168.1c6.427-6.805,46.124-49.527,65.406-57.088-10.208,26.465-27.977,49.527-44.234,72.211-15.879,22.306-29.867,46.124-46.124,68.43C269.352,276.232,251.582,300.806,233.813,325.381Z",
    transform: "translate(-32.299 -16.772)",
    fill: "#99c2fd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(11.143 13.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M310.789,613.219a297.9,297.9,0,0,1-204.913-81.285c-58.6-54.82-92.249-129.3-94.517-209.071-3.025-80.15,25.709-156.52,80.528-215.121s129.3-92.249,209.071-94.517a296.444,296.444,0,0,1,99.81,13.61,9.3,9.3,0,0,1,6.049,12.1,9.3,9.3,0,0,1-12.1,6.049,288.972,288.972,0,0,0-93.383-12.854C226.48,34.4,156.915,66.155,105.5,120.974c-51.039,54.442-77.882,125.9-75.614,201.132s34.026,144.422,88.846,195.839a279.66,279.66,0,0,0,201.132,75.992c74.857-2.268,144.422-34.026,195.839-88.846a280.663,280.663,0,0,0-1.89-386.385c-3.781-3.781-3.4-9.83.378-13.61s9.83-3.4,13.61.378a299.122,299.122,0,0,1,83.175,198.107c2.646,80.15-26.087,156.52-80.906,214.742-54.82,58.6-129.3,92.249-209.072,94.517C317.216,612.841,313.814,613.219,310.789,613.219Z",
    transform: "translate(-11.143 -13.055)",
    fill: "#c1c1c1"
  }))))));
};
export default __webpack_public_path__ + "static/media/Icons_Idle_10_Transfer.3b6f8597.svg";
export { SvgComponent as ReactComponent };